import React, { useRef, useState } from 'react';
import c from 'classnames';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ButtonWrapper = ({ children, type, href = '', onClick = () => { }, classNames = '', ...props }) => {
  const [mousePositionRelativeX, setMousePositionRelativeX] = useState(0);
  const [mousePositionRelativeY, setMousePositionRelativeY] = useState(0);
  const [hover, setHover] = useState(false);

  const buttonRef = useRef();
  const TYPE_PRIMARY = 'primary';
  const TYPE_SECONDARY = 'secondary';
  const TYPE_INVERTED = 'inverted';
  const TYPE_TERTIARY = 'tertiary';

  const buttonClasses = c(classNames, {
    'Button--primary': type === TYPE_PRIMARY,
    'Button--secondary': type === TYPE_SECONDARY,
    'Button--inverted': type === TYPE_INVERTED,
    'Button--tertiary': type === TYPE_TERTIARY,
  });

  const setMousePosition = (event) => {
    const bounds = event.target.getBoundingClientRect();
    setMousePositionRelativeX(event.clientX - bounds.left);
    setMousePositionRelativeY(event.clientY - bounds.top);
  };

  const onMouseEnter = (event) => {
    setMousePosition(event);
    setHover(true);
  };

  const onMouseLeave = (event) => {
    setMousePosition(event);
    setHover(false);
  };


  ((url) => {
    if (/^internal:/.test(url)) {
      href = href.replace(/^internal:/, '');
      return true;
    }

    return false;
  })(href);

  ((url) => {
    if (/^entity:/.test(url)) {
      href = href.replace(/^entity:/, '');
      return true;
    }

    return false;
  })(href);

  switch (type) {
    case TYPE_TERTIARY:
      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Button {...props} className={buttonClasses} href={href} onClick={onClick} primary={false}>
            {children}
            <i className="icon icon-arrow icon-variant-7" />
          </Button>
        </>
      );

    case TYPE_PRIMARY:
    case TYPE_SECONDARY:
    default:
      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Button
            forwardRef={buttonRef}
            className={buttonClasses}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            primary={false}
            href={href}
            {...props}
          >
            <div
              className="Button__circle"
              style={{
                left: `${mousePositionRelativeX}px`,
                top: `${mousePositionRelativeY}px`,
                transform: `${hover ? 'scale(500)' : 'scale(1)'}`,
              }}
            />

            <div className="Button__inner">
              {children}
            </div>
          </Button>
        </>
      );
  }
};

export default ButtonWrapper;
